var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"items":_vm.filterOptions,"label":_vm.$t('debugPage.filter')},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_c('data-table',{attrs:{"url":"debug_view","initial-url-search-params":_vm.params,"enable-delete":false,"enable-add":false,"enable-edit":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }